import {Injectable} from "@angular/core";
import {IClinicalResponse} from "../interfaces/clinical.response";
import {PatientResponseService} from "./patient.response.service";

/**
 * Created by stanislavk on 09/03/2017.
 */

@Injectable({ providedIn: 'root' })
  export class ClinicalResponseService {
	constructor(private patientResponseService : PatientResponseService) { }

	/**
	 * Changes the prototype of patient object returned from server.
	 * @param res Server response in IClinicalResponse format.
     */
	public clinicalResponseProcess(res:IClinicalResponse | IClinicalResponse[]) {
		Array.isArray(res) ? res.forEach(res => this.patientResponseService.patientResponseProcess(res.patient)) :
		this.patientResponseService.patientResponseProcess(res.patient);
	}
}
